import { createCanvas } from '../utils/canvas';

const vertexShader2D = `
        precision highp float;
        attribute vec4 position;
        attribute vec4 inputTextureCoordinate;
        varying vec2 textureCoordinate;

        void main() {
            gl_Position = position;
            textureCoordinate = vec2((position.x+1.0)/2.0, 1.0-(position.y+1.0)/2.0);
        }
    `;

const setAlphaWithMaskAlphaFragmentShaderString = `
         uniform vec2 blurVectorX;
         uniform vec2 blurVectorY;
         uniform sampler2D texture;
         uniform sampler2D maskTexture;
         
         uniform int type;
         
         varying vec2 textureCoordinate;

         vec4 avgBlur(sampler2D tex)
         {
             float coefficient = 1.0;
             vec4 avgValue = vec4(0.0);
             vec4 coefficientSum = vec4(0);
             
             for (int i = -kernelSize; i <= kernelSize; i++) {
                 for (int j = -kernelSize; j <= kernelSize; j++) {
                     avgValue += texture2D(tex, textureCoordinate + float(i) * blurVectorX + float(j) * blurVectorY) * coefficient;
                     coefficientSum += coefficient;
                 }
             }
            
             return avgValue / coefficientSum;
         }
         
         vec4 avgBlurWithMul(sampler2D tex, sampler2D factorTex, bool oneMinusFactor)
         {
             float coefficient = 1.0;
             vec4 avgValue = vec4(0.0);
             vec4 coefficientSum = vec4(0);
             
             for (int i = -kernelSize; i <= kernelSize; i++) {
                 for (int j = -kernelSize; j <= kernelSize; j++) {
                     float factor = texture2D(factorTex, textureCoordinate + float(i) * blurVectorX + float(j) * blurVectorY).a;
                     if (oneMinusFactor) {
                         factor = 1.0 - factor;
                     }
                     vec4 mergeFacotr = vec4(factor);
                     avgValue += texture2D(tex, textureCoordinate + float(i) * blurVectorX + float(j) * blurVectorY) * mergeFacotr * coefficient;
                     coefficientSum += coefficient;
                 }
             }
            
             return avgValue / coefficientSum;
         }

         void main()
         {
              vec4 srcImage = texture2D(texture, textureCoordinate);
              vec4 maskImage = texture2D(maskTexture, textureCoordinate);
             
                if (type == 0) {
                     // 前景提取，算法由实验室提供：https://cf.meitu.com/confluence/pages/viewpage.action?pageId=264073451
                     float alpha = maskImage.a;
                     float blurredAlpha = avgBlur(maskTexture).a;
                     vec3 blurredFA = avgBlurWithMul(texture, maskTexture, false).rgb;
                     vec3 blurredF = blurredFA / (blurredAlpha + 0.0001);
                     
                     vec3 blurredB1A = avgBlurWithMul(texture, maskTexture, true).rgb;
                     vec3 blurredB = blurredB1A / (1.0 - blurredAlpha + 0.0001);
                     vec3 tmp = srcImage.rgb + blurredF * (-alpha) + blurredB * (alpha-1.0);
                     vec3 fore = blurredF + tmp * (alpha);
    
                     gl_FragColor = vec4(fore * srcImage.a * maskImage.a, srcImage.a * maskImage.a);
                } else {
                    gl_FragColor = vec4(srcImage.rgb, 1.0);
                }
                 
         }
    `;

const newSetAlphaWithMaskAlphaFragmentShaderString = `
         precision highp float;
         uniform sampler2D texture;
         uniform sampler2D maskTexture;
         uniform sampler2D blurred_alpha;
         uniform sampler2D blurred_FA;
         uniform sampler2D blurred_B1A;
         varying vec2 textureCoordinate;

         void main()
         {
              vec4 srcImage = texture2D(texture, textureCoordinate);
              vec4 maskImage = texture2D(maskTexture, textureCoordinate);

              float alpha = maskImage.a;
              float blurredAlpha = texture2D(blurred_alpha, textureCoordinate).a;
            //   vec3 blurredFA = texture2D(blurred_FA, textureCoordinate).rgb;
              vec4 blurredFALoad = texture2D(blurred_FA, textureCoordinate);
              vec3 blurredFA = blurredFALoad.rgb;//srcImage.rgb * blurredFALoad.a;

              vec3 blurredF = blurredFA / (blurredAlpha + 0.0001);

              vec4 blurredB1ALoad = texture2D(blurred_B1A, textureCoordinate); 
            //   vec3 blurredB1A = blurredB1ALoad.rgb * blurredB1ALoad.a * (1.0-blurredAlpha);
            vec3 blurredB1A = blurredB1ALoad.rgb;//srcImage.rgb * (1.0-blurredAlpha);

            //   vec3 blurredB1A = texture2D(blurred_B1A, textureCoordinate).rgb;
            //   vec3 blurredB = blurredB1A / (1.0 - blurredAlpha + 0.0001);
            vec3 blurredB = blurredB1A * blurredB1ALoad.a / (1.0 - blurredAlpha + 0.0001);
              vec3 tmp = srcImage.rgb + blurredF * (-alpha) + blurredB * (alpha-1.0);
              vec3 fore = blurredF + tmp * (alpha);

              gl_FragColor = vec4(fore * srcImage.a * maskImage.a, srcImage.a * maskImage.a);
         }
    `;

const AVGBLURFilterFragmentShaderString = `
    precision mediump float;
    uniform sampler2D uSampler;
    varying vec2 vCoordinate;
    // uniform int uBlurRadius;
    uniform vec2 uBlurOffset;
    // uniform float coefficients[4];

    void main()
    {
        vec4 texel = texture2D(uSampler, vCoordinate);
        vec4 inputTexel = texel;
        vec4 avgValue = vec4(0.0);
        float coefficientSum = 0.0;
        float coefficients[4];//{0.498678,0.228311,0.021910, 0.021910};
        coefficients[0] = 0.498678;
        coefficients[1] = 0.228311;
        coefficients[2] = 0.021910;
        coefficients[3] = 0.021910;
        
        // center pixel
        avgValue += texel * coefficients[0];
        coefficientSum += coefficients[0];
        // todo kernelSize => 3  解决webgl编译不过问题
        for (int i = 1; i <= 3; i++) {
            avgValue += texture2D(uSampler, vCoordinate - float(i) * uBlurOffset) * coefficients[i];
            avgValue += texture2D(uSampler, vCoordinate + float(i) * uBlurOffset) * coefficients[i];
            coefficientSum += 2.0 * coefficients[i];
        }
        
        texel = avgValue / coefficientSum;
        gl_FragColor = texel;
    }
`;

const GaussiaVFilterFragmentShaderString = `
    precision mediump float;
    uniform sampler2D texture;
    uniform float fsize;
    varying vec2 textureCoordinate;
    vec4 gauss()
    {
        vec4 sum = vec4(0.0);
        sum += texture2D(texture, textureCoordinate + vec2(-4.0*fsize, 0.0)) * 0.05;
        sum += texture2D(texture, textureCoordinate + vec2(-3.0*fsize, 0.0)) * 0.09;
        sum += texture2D(texture, textureCoordinate + vec2(-2.0*fsize, 0.0)) * 0.12;
        sum += texture2D(texture, textureCoordinate + vec2(-1.0*fsize, 0.0)) * 0.15;
        sum += texture2D(texture, textureCoordinate) * 0.18;
        sum += texture2D(texture, textureCoordinate + vec2( 1.0*fsize, 0.0)) * 0.15;
        sum += texture2D(texture, textureCoordinate + vec2( 2.0*fsize, 0.0)) * 0.12;
        sum += texture2D(texture, textureCoordinate + vec2( 3.0*fsize, 0.0)) * 0.09;
        sum += texture2D(texture, textureCoordinate + vec2( 4.0*fsize, 0.0)) * 0.05;
        return sum;
    }
    void main()
    {
        gl_FragColor = gauss();
    }
`;

const GaussiaHFilterFragmentShaderString = `
    precision mediump float;
    uniform sampler2D texture;
    uniform float fsize;
    varying vec2 textureCoordinate;
    vec4 gauss()
    {
        vec4 sum = vec4(0.0);
        sum += texture2D(texture, textureCoordinate + vec2(0,-fsize*4.0)) * 0.05;
        sum += texture2D(texture, textureCoordinate + vec2(0,-fsize*3.0)) * 0.09;
        sum += texture2D(texture, textureCoordinate + vec2(0,-fsize*2.0)) * 0.12;
        sum += texture2D(texture, textureCoordinate + vec2(0,-fsize)) * 0.15;
        sum += texture2D(texture, textureCoordinate) * 0.18;
        sum += texture2D(texture, textureCoordinate + vec2(0,fsize)) * 0.15;
        sum += texture2D(texture, textureCoordinate + vec2(0,fsize*2.0)) * 0.12;
        sum += texture2D(texture, textureCoordinate + vec2(0,fsize*3.0)) * 0.09;
        sum += texture2D(texture, textureCoordinate + vec2(0,fsize*4.0)) * 0.05;
        return sum;
    }
    void main()
    {
        gl_FragColor = gauss();
    }
`;

const AVGHFilterFragmentShaderString = `
    precision mediump float;
    varying vec2 textureCoordinate;
    uniform sampler2D texture;
    uniform float textureWidth;
    uniform float textureHeight;
    uniform float size;
    const int  radius = 8;
    // const int kernelSize = 40;
    void main()
    {        
        
        vec4 sum            = vec4(0.0);
        vec4 result         = vec4(0.0);
        vec2 unit_uv        = vec2(size / textureWidth,size / textureHeight)*1.0;
        vec4 curColor       = texture2D(texture, textureCoordinate);

        vec4 centerPixel    = curColor;
        
        float sum_weight    = 1.0;
        //horizontal
        for(int i=-radius;i<=radius;i++)
        {
            vec2 curRightCoordinate = textureCoordinate+vec2(float(i),0.0)*unit_uv;
            vec2 curLeftCoordinate  = textureCoordinate+vec2(float(i),0.0)*unit_uv;
            sum += texture2D(texture,curRightCoordinate);
            sum += texture2D(texture,curLeftCoordinate);
            sum_weight+=2.0;
        }
        
        result = (sum+centerPixel)/sum_weight;
        
        gl_FragColor = result;
    }
`;

const AVGVFilterFragmentShaderString = `
    precision mediump float;
    varying vec2 textureCoordinate;
    uniform sampler2D texture;
    uniform float textureWidth;
    uniform float textureHeight;
    const int  radius = 8;
    uniform float size;

    void main()
    { 
        vec4 sum            = vec4(0.0);
        vec4 result         = vec4(0.0);
        vec2 unit_uv        = vec2(size / textureWidth,size / textureHeight)*1.0;
        vec4 centerPixel    = texture2D(texture, textureCoordinate);
        float  sum_weight   = 1.0;
        
        //vertical
        for(int i=-radius;i<=radius;i++)
        {
            vec2 curBottomCoordinate    = textureCoordinate+vec2(0.0,float(i))*unit_uv;
            vec2 curTopCoordinate       = textureCoordinate+vec2(0.0,float(i))*unit_uv;
            sum+=texture2D(texture,curBottomCoordinate);
            sum+=texture2D(texture,curTopCoordinate);
            sum_weight+=2.0;
        }
        
        result = (sum+centerPixel)/sum_weight;
        
        gl_FragColor = result;
    }
`;

const MulFragmentShaderString = `
    precision mediump float;
    uniform sampler2D texture1;
    uniform sampler2D texture2;
    uniform int type;
    varying vec2 textureCoordinate;

    vec4 avgBlurWithMul(sampler2D tex, sampler2D factorTex, bool oneMinusFactor)
    {
        float coefficient = 1.0;
        vec4 avgValue = vec4(0.0);
        vec4 coefficientSum = vec4(0);
        
                float factor = texture2D(factorTex, textureCoordinate).a;
                if (oneMinusFactor) {
                    factor = 1.0 - factor;
                }
                vec4 mergeFacotr = vec4(factor);
                avgValue += texture2D(tex, textureCoordinate) * mergeFacotr * coefficient;
                coefficientSum += coefficient;
       
        return avgValue / coefficientSum;
    }

    void main()
    {   
        vec4 color1 = texture2D(texture1, textureCoordinate);
        vec4 color2 = texture2D(texture2, textureCoordinate);
        // if (type == 1) {
        //     gl_FragColor = avgBlurWithMul(texture1, texture2, false);//color1 * color2;
        // } else if (type == 2) {
        //     // todo:
        //     // gl_FragColor = color1 / color2;
        // } else if (type == 3) {
        //     gl_FragColor = avgBlurWithMul(texture1, texture2, true);//color1 * (vec4(1.0)-color2);
        // }  
        
        if (type == 1) {
            gl_FragColor = mix(vec4(0.0,0.0,0.0,1.0), color1, color2.a);//avgBlurWithMul(texture1, texture2, false);//color1 * color2;
        } else if (type == 2) {
            // todo:
            // gl_FragColor = color1 / color2;
        } else if (type == 3) {
            gl_FragColor = mix(vec4(0.0,0.0,0.0,1.0), color1, 1.0-color2.a);//avgBlurWithMul(texture1, texture2, true);//color1 * (vec4(1.0)-color2);
        }  
    }
`;

function createShader(gl: any, type: number, source: string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        return shader;
    }
    console.log(gl.getShaderInfoLog(shader));
    gl.deleteShader(shader);
}

function createProgram(gl: any, vertexShader: any, fragmentShader: any) {
    const program = gl.createProgram();
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (gl.getProgramParameter(program, gl.LINK_STATUS)) {
        // gl.useProgram(program);
        return program;
    }
    console.error(gl.getProgramInfoLog(program));
    gl.deleteProgram(program);
}

function createTextureByImageObject(gl: any, imgObject: any) {
    const textureObject = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, textureObject);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, imgObject);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    return textureObject;
}

const vertices = [1.0, 1.0, 1.0, -1.0, -1.0, 1.0, -1.0, -1.0];

export async function blurFilterRun(
    width: number,
    height: number,
    imgSrc?: HTMLCanvasElement | HTMLImageElement,
    imgMask?: HTMLCanvasElement | HTMLImageElement,
) {
    // console.time('Time### blur total cost');
    // console.time('Time### createCanvas');

    const resultCanvas = createCanvas(width, height);

    // console.timeEnd('Time### createCanvas');

    // console.time('Time### draw one');
    const webgl = resultCanvas.getContext('webgl');
    if (webgl == null) {
        return null;
    }
    webgl.viewport(0, 0, width, height);

    const vertexShader = createShader(webgl, webgl.VERTEX_SHADER, vertexShader2D);

    let blurSize = 90;
    const standardWH = 4000;
    blurSize = Math.floor((Math.min(width, height) / standardWH) * blurSize);
    // console.error("wck----> " + blurSize);
    const newFragmentShaderString = `precision highp float;
        const int kernelSize = ${blurSize};
        ${setAlphaWithMaskAlphaFragmentShaderString}`;

    const fragmentShader = createShader(webgl, webgl.FRAGMENT_SHADER, newFragmentShaderString);
    const program = createProgram(webgl, vertexShader, fragmentShader);

    const srcTexture = createTextureByImageObject(webgl, imgSrc);
    const maskTexture = createTextureByImageObject(webgl, imgMask);

    webgl.useProgram(program);

    const buffer = webgl.createBuffer();

    webgl.bindBuffer(webgl.ARRAY_BUFFER, buffer);
    webgl.bufferData(webgl.ARRAY_BUFFER, new Float32Array(vertices), webgl.STATIC_DRAW);

    const v4PositionIndex = webgl.getAttribLocation(program, 'position');
    webgl.enableVertexAttribArray(v4PositionIndex);
    webgl.vertexAttribPointer(v4PositionIndex, 2, webgl.FLOAT, false, 0, 0);

    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, srcTexture);
    const uniformSrc = webgl.getUniformLocation(program, 'texture');
    webgl.uniform1i(uniformSrc, 0);

    webgl.activeTexture(webgl.TEXTURE1);
    webgl.bindTexture(webgl.TEXTURE_2D, maskTexture);
    const uniformMask = webgl.getUniformLocation(program, 'maskTexture');
    webgl.uniform1i(uniformMask, 1);

    const uniformType = webgl.getUniformLocation(program, 'type');
    webgl.uniform1i(uniformType, 0);

    const blurVectorX = webgl.getUniformLocation(program, 'blurVectorX');
    const blurVectorXValue = 1.0 / width;
    webgl.uniform2fv(blurVectorX, [blurVectorXValue, 0.0]);
    const blurVectorY = webgl.getUniformLocation(program, 'blurVectorY');
    const blurVectorYValue = 1.0 / height;
    webgl.uniform2fv(blurVectorY, [0.0, blurVectorYValue]);
    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    // console.timeEnd('Time### draw one');

    // console.time('Time### convertCanvasToImage');
    const resImage1 = await convertCanvasToImage(createCanvas(100, 100));
    // console.timeEnd('Time### convertCanvasToImage');

    // console.time('Time### draw two');
    // createTextureByImageObject(webgl, resImage1, webgl.TEXTURE0);
    // webgl.uniform1i(uniformSrc, 0);
    // webgl.uniform1i(uniformType, 0);
    // webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    // console.timeEnd('Time### draw two');

    webgl.deleteProgram(program);
    webgl.deleteShader(fragmentShader);
    webgl.deleteShader(vertexShader);
    webgl.deleteTexture(srcTexture);
    webgl.deleteTexture(maskTexture);

    // console.timeEnd('Time### blur total cost');
    return resultCanvas;
}

async function convertCanvasToImage(canvas: HTMLCanvasElement) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        // canvas.toDataURL返回的是一串Base64编码的URL,当然,浏览器自己肯定支持
        // 指定格式PNG
        image.src = canvas.toDataURL('image/png');
        image.onload = () => {
            resolve(image);
        };
    });
}

/**
 * 获取模糊半径
 * @param width 画布宽度
 * @param height 画布高度
 */
export function getFsizeValue(width: number, height: number) {
    const blurSize = 1.1;
    const standardWH = 501;
    const fsizeValue = (Math.min(width, height) / standardWH) * blurSize;
    return fsizeValue;
}

/**
 *
 * @param width 画布宽度
 * @param height 画布高度
 * @param imgSrc 原图
 * @param imgMask 蒙版图
 * @param options.manualLoseContext 手动销毁 gl context，用于解决在批量抠图场景下，浏览器对 gl context 有最大限制的问题
 * @returns
 */
export async function newBlurFilterRun(
    width: number,
    height: number,
    imgSrc: HTMLCanvasElement | HTMLImageElement,
    imgMask: HTMLCanvasElement | HTMLImageElement,
    blursizeValue?: number,
) {
    // console.error("wck----> newBlurFilterRun");
    // console.time('Time### blur total cost');
    const resultCanvas = createCanvas(width, height);

    const webgl = resultCanvas.getContext('webgl');
    if (webgl == null) {
        return null;
    }
    webgl.viewport(0, 0, width, height);

    const fsizeValue = blursizeValue || getFsizeValue(width, height);
    // console.error("wck----> fsizeValue = " + fsizeValue);

    // gauss H V
    const vertexShader = createShader(webgl, webgl.VERTEX_SHADER, vertexShader2D);
    const fragmentShaderH = createShader(webgl, webgl.FRAGMENT_SHADER, AVGHFilterFragmentShaderString);
    const fragmentShaderV = createShader(webgl, webgl.FRAGMENT_SHADER, AVGVFilterFragmentShaderString);
    const fragmentShaderMul = createShader(webgl, webgl.FRAGMENT_SHADER, MulFragmentShaderString);
    const fragmentShaderLast = createShader(webgl, webgl.FRAGMENT_SHADER, newSetAlphaWithMaskAlphaFragmentShaderString);

    const programH = createProgram(webgl, vertexShader, fragmentShaderH);
    const programV = createProgram(webgl, vertexShader, fragmentShaderV);
    const programMul = createProgram(webgl, vertexShader, fragmentShaderMul);
    const programLast = createProgram(webgl, vertexShader, fragmentShaderLast);

    // texture
    const srcTexture = createTextureByImageObject(webgl, imgSrc);
    const maskTexture = createTextureByImageObject(webgl, imgMask);

    // webgl buffer
    const buffer = webgl.createBuffer();
    webgl.bindBuffer(webgl.ARRAY_BUFFER, buffer);
    webgl.bufferData(webgl.ARRAY_BUFFER, new Float32Array(vertices), webgl.STATIC_DRAW);

    // gauss H blur
    webgl.useProgram(programH);
    webgl.enableVertexAttribArray(webgl.getAttribLocation(programH, 'position'));
    webgl.vertexAttribPointer(webgl.getAttribLocation(programH, 'position'), 2, webgl.FLOAT, false, 0, 0);
    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, maskTexture);
    webgl.uniform1i(webgl.getUniformLocation(programH, 'texture'), 0);
    // webgl.uniform1fv(webgl.getUniformLocation(programH, "fsize"), [fsizeValue]);
    webgl.uniform1fv(webgl.getUniformLocation(programH, 'textureWidth'), [width]);
    webgl.uniform1fv(webgl.getUniformLocation(programH, 'textureHeight'), [height]);
    webgl.uniform1fv(webgl.getUniformLocation(programH, 'size'), [fsizeValue]);
    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    let gaussHImage = resultCanvas;
    let gaussHTexture = createTextureByImageObject(webgl, gaussHImage);

    // gauss V blur
    webgl.useProgram(programV);
    webgl.enableVertexAttribArray(webgl.getAttribLocation(programV, 'position'));
    webgl.vertexAttribPointer(webgl.getAttribLocation(programV, 'position'), 2, webgl.FLOAT, false, 0, 0);
    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, gaussHTexture);
    webgl.uniform1i(webgl.getUniformLocation(programV, 'texture'), 0);
    // webgl.uniform1fv(webgl.getUniformLocation(programV, "fsize"), [fsizeValue]);
    webgl.uniform1fv(webgl.getUniformLocation(programV, 'textureWidth'), [width]);
    webgl.uniform1fv(webgl.getUniformLocation(programV, 'textureHeight'), [height]);
    webgl.uniform1fv(webgl.getUniformLocation(programV, 'size'), [fsizeValue]);
    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    const blurred_alpha_image = resultCanvas;
    const blurred_alpha = createTextureByImageObject(webgl, blurred_alpha_image);

    webgl.deleteTexture(gaussHTexture);

    // mul blurred_FA
    webgl.useProgram(programMul);
    webgl.enableVertexAttribArray(webgl.getAttribLocation(programMul, 'position'));
    webgl.vertexAttribPointer(webgl.getAttribLocation(programMul, 'position'), 2, webgl.FLOAT, false, 0, 0);
    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, srcTexture);
    webgl.uniform1i(webgl.getUniformLocation(programMul, 'texture1'), 0);
    webgl.activeTexture(webgl.TEXTURE1);
    webgl.bindTexture(webgl.TEXTURE_2D, maskTexture);
    webgl.uniform1i(webgl.getUniformLocation(programMul, 'texture2'), 1);
    webgl.uniform1iv(webgl.getUniformLocation(programMul, 'type'), [1]);
    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    let blurred_FA_image = resultCanvas;
    let blurred_FA = createTextureByImageObject(webgl, blurred_FA_image);

    // fsizeValue = 1
    // gauss H blur
    webgl.useProgram(programH);
    webgl.enableVertexAttribArray(webgl.getAttribLocation(programH, 'position'));
    webgl.vertexAttribPointer(webgl.getAttribLocation(programH, 'position'), 2, webgl.FLOAT, false, 0, 0);
    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, blurred_FA);
    webgl.uniform1i(webgl.getUniformLocation(programH, 'texture'), 0);
    // webgl.uniform1fv(webgl.getUniformLocation(programH, "fsize"), [fsizeValue]);
    webgl.uniform1fv(webgl.getUniformLocation(programH, 'textureWidth'), [width]);
    webgl.uniform1fv(webgl.getUniformLocation(programH, 'textureHeight'), [height]);
    webgl.uniform1fv(webgl.getUniformLocation(programH, 'size'), [fsizeValue]);
    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    gaussHImage = resultCanvas;
    gaussHTexture = createTextureByImageObject(webgl, gaussHImage);
    webgl.deleteTexture(blurred_FA);

    // gauss V blur
    webgl.useProgram(programV);
    webgl.enableVertexAttribArray(webgl.getAttribLocation(programV, 'position'));
    webgl.vertexAttribPointer(webgl.getAttribLocation(programV, 'position'), 2, webgl.FLOAT, false, 0, 0);
    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, gaussHTexture);
    webgl.uniform1i(webgl.getUniformLocation(programV, 'texture'), 0);
    // webgl.uniform1fv(webgl.getUniformLocation(programV, "fsize"), [fsizeValue]);
    webgl.uniform1fv(webgl.getUniformLocation(programV, 'textureWidth'), [width]);
    webgl.uniform1fv(webgl.getUniformLocation(programV, 'textureHeight'), [height]);
    webgl.uniform1fv(webgl.getUniformLocation(programV, 'size'), [fsizeValue]);
    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    blurred_FA_image = resultCanvas;
    blurred_FA = createTextureByImageObject(webgl, blurred_FA_image);

    webgl.deleteTexture(gaussHTexture);

    // mul blurred_B1A
    webgl.useProgram(programMul);
    webgl.enableVertexAttribArray(webgl.getAttribLocation(programMul, 'position'));
    webgl.vertexAttribPointer(webgl.getAttribLocation(programMul, 'position'), 2, webgl.FLOAT, false, 0, 0);
    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, srcTexture);
    webgl.uniform1i(webgl.getUniformLocation(programMul, 'texture1'), 0);
    webgl.activeTexture(webgl.TEXTURE1);
    webgl.bindTexture(webgl.TEXTURE_2D, maskTexture);
    webgl.uniform1i(webgl.getUniformLocation(programMul, 'texture2'), 1);
    webgl.uniform1iv(webgl.getUniformLocation(programMul, 'type'), [3]);
    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    let blurred_B1A_image = resultCanvas;
    let blurred_B1A = createTextureByImageObject(webgl, blurred_B1A_image);

    // gauss H blur
    webgl.useProgram(programH);
    webgl.enableVertexAttribArray(webgl.getAttribLocation(programH, 'position'));
    webgl.vertexAttribPointer(webgl.getAttribLocation(programH, 'position'), 2, webgl.FLOAT, false, 0, 0);
    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, blurred_B1A);
    webgl.uniform1i(webgl.getUniformLocation(programH, 'texture'), 0);
    // webgl.uniform1fv(webgl.getUniformLocation(programH, "fsize"), [fsizeValue]);
    webgl.uniform1fv(webgl.getUniformLocation(programH, 'textureWidth'), [width]);
    webgl.uniform1fv(webgl.getUniformLocation(programH, 'textureHeight'), [height]);
    webgl.uniform1fv(webgl.getUniformLocation(programH, 'size'), [fsizeValue]);
    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    gaussHImage = resultCanvas;
    gaussHTexture = createTextureByImageObject(webgl, gaussHImage);

    webgl.deleteTexture(blurred_B1A);

    // gauss V blur
    webgl.useProgram(programV);
    webgl.enableVertexAttribArray(webgl.getAttribLocation(programV, 'position'));
    webgl.vertexAttribPointer(webgl.getAttribLocation(programV, 'position'), 2, webgl.FLOAT, false, 0, 0);
    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, gaussHTexture);
    webgl.uniform1i(webgl.getUniformLocation(programV, 'texture'), 0);
    // webgl.uniform1fv(webgl.getUniformLocation(programV, "fsize"), [fsizeValue]);
    webgl.uniform1fv(webgl.getUniformLocation(programV, 'textureWidth'), [width]);
    webgl.uniform1fv(webgl.getUniformLocation(programV, 'textureHeight'), [height]);
    webgl.uniform1fv(webgl.getUniformLocation(programV, 'size'), [fsizeValue]);
    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);
    blurred_B1A_image = resultCanvas;
    blurred_B1A = createTextureByImageObject(webgl, blurred_B1A_image);

    webgl.deleteTexture(gaussHTexture);

    webgl.useProgram(programLast);
    webgl.enableVertexAttribArray(webgl.getAttribLocation(programLast, 'position'));
    webgl.vertexAttribPointer(webgl.getAttribLocation(programLast, 'position'), 2, webgl.FLOAT, false, 0, 0);

    webgl.activeTexture(webgl.TEXTURE0);
    webgl.bindTexture(webgl.TEXTURE_2D, srcTexture);
    webgl.uniform1i(webgl.getUniformLocation(programLast, 'texture'), 0);

    webgl.activeTexture(webgl.TEXTURE1);
    webgl.bindTexture(webgl.TEXTURE_2D, maskTexture);
    webgl.uniform1i(webgl.getUniformLocation(programLast, 'maskTexture'), 1);

    webgl.activeTexture(webgl.TEXTURE2);
    webgl.bindTexture(webgl.TEXTURE_2D, blurred_alpha);
    webgl.uniform1i(webgl.getUniformLocation(programLast, 'blurred_alpha'), 2);

    webgl.activeTexture(webgl.TEXTURE3);
    webgl.bindTexture(webgl.TEXTURE_2D, blurred_FA);
    webgl.uniform1i(webgl.getUniformLocation(programLast, 'blurred_FA'), 3);

    webgl.activeTexture(webgl.TEXTURE4);
    webgl.bindTexture(webgl.TEXTURE_2D, blurred_B1A);
    webgl.uniform1i(webgl.getUniformLocation(programLast, 'blurred_B1A'), 4);

    webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, 4);

    webgl.deleteProgram(programH);
    webgl.deleteProgram(programV);
    webgl.deleteProgram(programMul);
    webgl.deleteProgram(programLast);

    webgl.deleteShader(vertexShader);
    webgl.deleteShader(fragmentShaderH);
    webgl.deleteShader(fragmentShaderV);
    webgl.deleteShader(fragmentShaderMul);
    webgl.deleteShader(fragmentShaderLast);

    webgl.deleteTexture(srcTexture);
    webgl.deleteTexture(maskTexture);
    webgl.deleteTexture(blurred_alpha);
    webgl.deleteTexture(blurred_FA);
    webgl.deleteTexture(blurred_B1A);

    // console.timeEnd('Time### blur total cost');

    // return resultCanvas;

    const newResultCanvas = createCanvas(width, height);
    const ctx = newResultCanvas.getContext('2d');

    ctx?.drawImage(resultCanvas, 0, 0, width, height);

    // 清除 WebGL 上下文的状态

    webgl.clear(webgl.COLOR_BUFFER_BIT | webgl.DEPTH_BUFFER_BIT);
    webgl.finish();

    // ATTENTION: 不同浏览器对 gl context 的最大数量限制不同，导致当超过最大数量时，gpu 会崩溃，页面黑屏再重新显示，canvas 全部变成空白
    // 主动释放这个耗时太长了，先注释掉
    // webgl.getExtension('WEBGL_lose_context')?.loseContext();

    return newResultCanvas;
}
